import { render, staticRenderFns } from "./HomeRankingRail.vue?vue&type=template&id=36ca9637"
import script from "./HomeRankingRail.vue?vue&type=script&lang=js"
export * from "./HomeRankingRail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports